import { InjectionToken } from '@angular/core';
import { AutomationsApi } from '../models/automations.model';

export const AUTOMATIONS_API = new InjectionToken<AutomationsApi>('AUTOMATIONS_API');
